<section class="bg-black text-white pt-32 pb-16 px-8 md:px-16">
  <div class="max-w-6xl mx-auto">
    <app-navigate-back class="mb-4"></app-navigate-back>
    <h1 class="text-4xl md:text-5xl font-black mb-4">Careers <span class="text-varroc-accent">&#64; Varroc Connect</span></h1>
    <p class="text-gray-400 text-lg">Diverse culture where curious minds collaborate. Explore current openings or submit your profile for future opportunities.</p>
  </div>
</section>

<!-- Tab Navigation -->
<div class="bg-black px-6 md:px-16">
  <div class="max-w-6xl mx-auto">
    <div class="flex border-b border-white/10 w-full max-w-lg">
      <button
        (click)="setTab('openings')"
        class="px-6 py-3 text-sm font-semibold transition-all duration-200 border-b-2 -mb-[1px]"
        [ngClass]="activeTab === 'openings' ? 'text-varroc-accent border-varroc-accent' : 'text-gray-500 border-transparent hover:text-varroc-accent'">
        Current Openings
        <span class="ml-2 px-2 py-0.5 text-xs rounded-full font-bold"
          [ngClass]="activeTab === 'openings' ? 'bg-varroc-accent text-white' : 'bg-white/10 text-gray-400'">
          {{ openJobs.length }}
        </span>
      </button>
      <button
        (click)="setTab('future')"
        class="px-6 py-3 text-sm font-semibold transition-all duration-200 border-b-2 -mb-[1px]"
        [ngClass]="activeTab === 'future' ? 'text-varroc-accent border-varroc-accent' : 'text-gray-500 border-transparent hover:text-varroc-accent'">
        Join Our Talent Pool
      </button>
    </div>
  </div>
</div>

<!-- ── Tab: Current Openings ── -->
<div *ngIf="activeTab === 'openings'" class="bg-black py-12 px-6 md:px-16">
  <div class="max-w-6xl mx-auto">

    <!-- Empty State -->
    <div *ngIf="openJobs.length === 0" class="flex flex-col items-center justify-center py-20 gap-6 text-center">
      <div class="w-20 h-20 bg-varroc-accent/10 rounded-full flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10 svg-stroke-gradient" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <div>
        <h3 class="text-2xl font-bold text-white">No open positions right now</h3>
        <p class="text-gray-400 mt-2 max-w-md text-sm">
          We're not actively hiring at the moment, but great talent is always welcome.
          Submit your profile and we'll reach out when a suitable role opens up.
        </p>
      </div>
      <button (click)="setTab('future')"
        class="px-6 py-3 bg-varroc-accent text-white rounded-lg font-medium hover:bg-varroc-accent-hover transition-colors duration-200 join_our_talent_pool_button_click">
        Join Our Talent Pool
      </button>
    </div>

    <!-- Jobs Grid -->
    <div *ngIf="openJobs.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div *ngFor="let job of openJobs"
        class="bg-white/5 border border-white/10 rounded-xl px-6 py-5 flex flex-col justify-between hover:bg-white/8 hover:border-varroc-accent/40 transition-all duration-200">
        <div class="border-t-2 pt-4 border-varroc-accent">
          <div class="flex flex-col items-start gap-1 border-l-2 pl-3 ml-2 mt-2 border-varroc-accent">
            <h2 class="text-base font-semibold text-white">{{ job.title }}</h2>
            <p class="text-sm text-gray-400 mt-1">{{ job.location }}</p>
          </div>
          <h3 class="text-sm font-semibold text-gray-300 mt-4 mb-2">Required Details</h3>
          <hr class="border-white/10">
          <ul class="mt-2 space-y-1 text-varroc-accent text-sm">
            <li>{{ job.experience }} of experience</li>
            <li>{{ job.employmentType }}</li>
          </ul>
          <hr class="mt-3 border-white/10">
        </div>
        <div class="flex justify-end mt-5">
          <a [routerLink]="job.route"
            class="px-4 py-2 bg-varroc-accent text-white rounded-md text-sm font-medium hover:bg-varroc-accent-hover transition-colors">
            Apply Now
          </a>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Tab: Join Our Talent Pool ── -->
<div *ngIf="activeTab === 'future'" class="bg-black py-12 px-6 md:px-16">
  <div class="max-w-2xl mx-auto">

    <div class="mb-8">
      <h3 class="text-2xl font-bold text-white">Join Our Talent Pool</h3>
      <p class="text-gray-400 mt-2 text-sm">
        We're not actively hiring right now, but submit your profile and we'll reach out when a suitable opening comes up.
      </p>
    </div>

    <!-- Form -->
    <div *ngIf="!futureFormSuccess">
      <form #futureForm="ngForm" (ngSubmit)="onFutureSubmit(futureForm)">

        <div class="grid gap-6 mb-6 md:grid-cols-2">
          <div>
            <label class="block mb-2 text-sm font-medium text-gray-300">First name <span class="text-red-400">&#42;</span></label>
            <input type="text" name="first_name" [(ngModel)]="futureFormData.first_name" required
              class="bg-white/5 border border-white/15 text-white text-sm rounded-lg focus:ring-varroc-accent focus:border-varroc-accent block w-full p-2.5 placeholder-gray-500" />
          </div>
          <div>
            <label class="block mb-2 text-sm font-medium text-gray-300">Last name <span class="text-red-400">&#42;</span></label>
            <input type="text" name="last_name" [(ngModel)]="futureFormData.last_name" required
              class="bg-white/5 border border-white/15 text-white text-sm rounded-lg focus:ring-varroc-accent focus:border-varroc-accent block w-full p-2.5 placeholder-gray-500" />
          </div>
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-300">Email address <span class="text-red-400">&#42;</span></label>
          <input type="email" name="emailId" [(ngModel)]="futureFormData.emailId" required email #futureEmail="ngModel"
            class="bg-white/5 border border-white/15 text-white text-sm rounded-lg focus:ring-varroc-accent focus:border-varroc-accent block w-full p-2.5 placeholder-gray-500"
            [class.border-red-500]="futureEmail.invalid && futureEmail.touched" />
          <p class="mt-1 text-sm text-red-500" *ngIf="futureEmail.touched && futureEmail.errors?.['required']">Email is required.</p>
          <p class="mt-1 text-sm text-red-500" *ngIf="futureEmail.touched && futureEmail.errors?.['email']">Please enter a valid email address.</p>
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-300">Phone Number <span class="text-red-400">&#42;</span></label>
          <input type="text" name="phone" [(ngModel)]="futureFormData.phone" required
            pattern="^[+]?[0-9]{10,13}$" maxlength="13" #futurePhone="ngModel"
            class="bg-white/5 border border-white/15 text-white text-sm rounded-lg focus:ring-varroc-accent focus:border-varroc-accent block w-full p-2.5 placeholder-gray-500"
            [class.border-red-500]="futurePhone.invalid && futurePhone.touched" />
          <p class="mt-1 text-sm text-red-500" *ngIf="futurePhone.touched && futurePhone.errors?.['required']">Phone number is required.</p>
          <p class="mt-1 text-sm text-red-500" *ngIf="futurePhone.touched && futurePhone.errors?.['pattern']">Please enter a valid phone number (10–13 digits, optional + prefix).</p>
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-300">Role Interested In <span class="text-red-400">&#42;</span></label>
          <select name="role" [(ngModel)]="futureFormData.role" required
            class="bg-[#111] border border-white/15 text-white text-sm rounded-lg focus:ring-varroc-accent focus:border-varroc-accent block w-full p-2.5">
            <option value="" disabled>Select a role</option>
            <option *ngFor="let role of futureRoles" [value]="role">{{ role }}</option>
            <option value="Other">Other / Not Listed</option>
          </select>
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-300">About Yourself <span class="text-red-400">&#42;</span></label>
          <textarea name="message" rows="4" [(ngModel)]="futureFormData.message" required
            class="block p-2.5 w-full text-sm text-white bg-white/5 rounded-lg border border-white/15 focus:ring-varroc-accent focus:border-varroc-accent placeholder-gray-500"
            placeholder="Tell us about your experience, skills, and why you'd be a great fit..."></textarea>
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-300">Upload Resume <span class="text-red-400">&#42;</span></label>
          <input type="file" (change)="onFutureFileChange($event)"
            class="block w-full text-sm text-gray-400 border border-white/15 rounded-lg cursor-pointer bg-white/5 focus:outline-none" />
          <p class="mt-1 text-sm text-gray-500">PDF, WORD, DOC, DOCX (MAX 1MB)</p>
        </div>

        <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4" role="alert" *ngIf="futureFormError">
          <p class="font-bold">Something went wrong</p>
          <p>Please ensure a resume is attached and try again later.</p>
        </div>

        <div class="flex justify-end">
          <button type="submit" [disabled]="futureFormLoading"
            class="px-6 py-2.5 bg-varroc-accent text-white font-medium rounded-lg text-sm hover:bg-varroc-accent-hover transition-colors duration-200 disabled:opacity-60 join_our_talent_pool_form_submit_profile_button ">
            {{ futureFormLoading ? 'Submitting...' : 'Submit Profile' }}
          </button>
        </div>

      </form>
    </div>

    <!-- Success State -->
    <div *ngIf="futureFormSuccess" class="flex flex-col items-center justify-center py-16 gap-5 text-center">
      <div class="w-16 h-16 bg-varroc-accent/15 rounded-full flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-varroc-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold text-white">Profile Submitted Successfully!</h3>
      <p class="text-gray-400 max-w-md text-sm">
        Thank you for your interest in joining Varroc Connect. We've received your profile and will reach out when a suitable role opens up.
      </p>
    </div>

  </div>
</div>
